module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASUlEQVQ4y2P4jwQ+MAww7wADDNgPAh7zfwZ7oLsGDe8D86Dg8f+BCw0GHjCU/jAMCh4wtiBCA88DBRADA3L8DSBv8OTpwVPWAQC+ocHxHjBmxAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNjo0MiswOTowMN960EEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjYrMDk6MDDL5wzeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00202_100x100.png
// module id = VhZP
// module chunks = 0